import React, { ReactNode } from 'react';

import { Icon, IconColorOptions } from '../Icon';

import './styles.scss';

interface Props {
    children: ReactNode;
    className?: string;
    icon?: string;
    iconSize?: string;
    iconColor?: IconColorOptions;
}

export const HelperText = ({ className = '', children, icon, iconSize, iconColor }: Props) => {
    return (
        <div className={`helper-text ${className}`}>
            {icon && (
                <Icon
                    icon={icon}
                    size={iconSize || '14'}
                    color={iconColor || 'info'}
                    className='helper-text__icon'
                />
            )}
            <div className='helper-text__content'>{children}</div>
        </div>
    );
};
